import React from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import './GeoLayout.css';

// Espace du responsable des hôtesses : même barre latérale que l'espace géolocalisation
function HotessesLayout({ onLogout }) {
  return (
    <div className="geo-layout">
      <nav className="geo-sidebar">
        <div className="sidebar-header">
          <h3>SP MerchFlow</h3>
          <p className="geo-subtitle">Responsable des hôtesses</p>
        </div>
        <ul>
          <li><NavLink to="/responsable-hotesses/presence">Présence des hôtesses</NavLink></li>
          <li><NavLink to="/responsable-hotesses/avis-consommateurs">Avis des consommateurs</NavLink></li>
          <li><NavLink to="/responsable-hotesses/controles-terrain">Contrôles des hôtesses</NavLink></li>
        </ul>
        <button onClick={onLogout} className="sidebar-logout-button">Déconnexion</button>
      </nav>
      <main className="geo-content">
        <Outlet />
      </main>
    </div>
  );
}

export default HotessesLayout;
